import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { CompaniesTable } from './CompaniesTable';

const BottomBlockComponent = ({
  data,
  events,
  onYearFilterChange,
  onCompaniesSortingChange,
  onGetNextPageData,
  onRowDoubleClicked,
}) => (
  <CompaniesTable
    data={data}
    events={events}
    onCompaniesSortingChange={onCompaniesSortingChange}
    onGetNextPageData={onGetNextPageData}
    onRowDoubleClicked={onRowDoubleClicked}
    onYearFilterChange={onYearFilterChange}
  />
);

BottomBlockComponent.propTypes = {
  data: PropTypes.instanceOf(Map).isRequired,
  events: PropTypes.instanceOf(Array).isRequired,
  onCompaniesSortingChange: PropTypes.func,
  onGetNextPageData: PropTypes.func,
  onRowDoubleClicked: PropTypes.func,
  onYearFilterChange: PropTypes.func,
};

/** Bottom block component. */
export const BottomBlock = memo(BottomBlockComponent);
